<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    name="account_number"
    :label="'Account Number'|pgettext('CompanyBankAccount')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormInput
      name="account_number"
      v-model="bankAccount.account_number"
      required
      autofocus
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="description"
    :label="'Description'|pgettext('CompanyBankAccount')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="description"
      v-model="bankAccount.description"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="iban"
    :label="'IBAN'|pgettext('CompanyBankAccount')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="iban"
      v-model="bankAccount.iban"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <hr>
  </hr>
  <ItpFormGroup
    name="valid_from"
    :label="'Validity'|pgettext('CompanyBankAccount')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    contentClass="form-row"
  >
    <DIV
      class="col"
    >
      <ItpFormDatetime
        name="valid_from"
        v-model="bankAccount.valid_from"
      >
      </ItpFormDatetime>
    </DIV>
    <DIV
      class="col"
    >
      <ItpFormDatetime
        name="valid_to"
        v-model="bankAccount.valid_to"
      >
      </ItpFormDatetime>
    </DIV>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    name="is_default"
    :label="'Default'|pgettext('Company')"
    :labelAlign="labelAlign"
  >
    <ItpFormCheckbox
      name="is_default"
      v-model="bankAccount.is_default"
    >
    </ItpFormCheckbox>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcCompanyBankAccountFieldset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  bankAccount!: object;

  @Watch('bankAccount')
  onBank_account(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("bankAccount")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8282: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8281: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8282 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8281 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8282,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8281],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8282,
      evh_7315092382398562_reload_8281,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("UcCompanyBankAccountFieldset", UcCompanyBankAccountFieldset);

</script>